import React, { useEffect, useState } from 'react';
import NavbarQuoteDetailStyle from './style';
import { useSelector } from 'react-redux';
import { quoteDetailSelector } from 'src/redux/selectors/quoteDetailSelector';
import ModalComponent from 'src/components/modalCustom';
import { routerQuoteDetailData } from 'src/const/enum';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import CopyLinkVersion from 'src/components/copyLinkVersion';
import icons from 'src/assets/icon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faShareNodes } from '@fortawesome/free-solid-svg-icons';
import { ENV } from 'src/const/evn';
import { Button, Flex } from 'antd';
import YourMasterComponent from 'src/components/yourMaster';
import { itinerarySelector } from 'src/redux/selectors/itinerarySelector';
import CartWrap from 'src/components/cartWrap';
import AvatarConsultant from 'src/components/avatarConsultant';
import ItineraryScrollComponent from 'src/components/itineraryLinkCroll';
import { apiDownLoadPDF } from 'src/api/apiDownloadPDF';
import { toast } from 'react-toastify';
import useIsPdfPage from 'src/hooks/useIsPdfPage';
import { multipleQuotesSelector } from 'src/redux/selectors/multipleQuotesSelector';
import { formatCurrency } from 'src/const/contain';
import images from 'src/assets/image';
import Lifetime from './lifetime';
import { paramsQuoteDetailSelector } from 'src/redux/selectors/paramsQuoteDetailSelector';
import PaymentSchedule from './paymentSchedule';
import loyaltySvg from "src/assets/image/loyalty.svg";

interface NavbarQuoteDetailProps {
    isPreview: boolean;
}

const NavbarQuoteDetail: React.FC<NavbarQuoteDetailProps> = ({ isPreview }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isLoadingDownloadPdf, setIsLoadingDownloadPdf] =
        useState<boolean>(false);

    const queryParams = new URLSearchParams(location.search);
    const quoteIdQuery = queryParams.get('id') || '';
    const queryParamsMultipleQuotes = queryParams.get('multipleQuotes');
    const isPdfPage = useIsPdfPage();

    const { ids: quotesArray = [] } = useSelector(multipleQuotesSelector);

    const {
        id: quoteId = '',
        resConsultant,
        price,
        isEvent,
        version,
        isSafariTemplate,
    } = useSelector(quoteDetailSelector);

    const params = useSelector(paramsQuoteDetailSelector);
    const getIsSafariTemplate = params?.isSafariTemplate ?? isSafariTemplate;

    const { totalDeposit } = price;
    const { id: versionId } = version;

    const { atAGlance } = useSelector(itinerarySelector);
    const {
        name: nameConsultant,
        jobTitle,
        companyName,
        email,
        telephone,
    } = resConsultant;
    const lastName = nameConsultant?.split(' ').slice(0, -1).join(' ');

    useEffect(() => {
        if (getIsSafariTemplate) {
            navigate(pathName('introduction'));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getIsSafariTemplate]);

    const handleShowModal = () => {
        setIsModalVisible(true);
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
    };

    const pathName = (path: string) => {
        return `/${
            isCheckPathName('quoteDetail') ? 'quoteDetail' : 'multipleQuotes'
        }/${path}?id=${quoteIdQuery}${
            queryParamsMultipleQuotes
                ? `&multipleQuotes=${queryParamsMultipleQuotes}`
                : ''
        }`;
    };

    const isCheckPathName = (path: string) => {
        return location.pathname.includes(path);
    };

    const handleDownloadPdf = async () => {
        try {
            setIsLoadingDownloadPdf(true);
            const response = await apiDownLoadPDF({
                quoteRef: quoteId,
                version: version?.version,
                url: `${ENV.PUBLIC_ENV}/download-pdf?id=${quoteId}`,
                format: 'A2',
            });

            if (
                response &&
                response instanceof Blob &&
                response.type === 'application/pdf'
            ) {
                const url = window.URL.createObjectURL(response);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = `Quote${quoteId}.pdf`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                toast.success('PDF downloaded successfully!');
                setIsLoadingDownloadPdf(false);
            } else {
                toast.error('Failed to download PDF');
                setIsLoadingDownloadPdf(false);
            }
        } catch (error) {
            toast.error('Failed to download PDF');
            setIsLoadingDownloadPdf(false);
        }
    };

    const renderConsultant = () => (
        <div className="card box-consultant">
            <Flex justify="space-between" align="top">
                <div className='consultant'>
                    <p>
                        “I’m {lastName} and I’ll be looking after your trip.”
                    </p>
                    <p className="golfer">{nameConsultant}</p>
                    {jobTitle && <p>{jobTitle}</p>}
                    {companyName && (
                        <p>
                            {companyName
                                ?.replace('Golf ', '')
                                ?.replace('plus', '+')}
                        </p>
                    )}
                </div>
                <AvatarConsultant />
            </Flex>
            <div className="box-right">
                {telephone && <p>{telephone}</p>}
                {email && <p className="email">{email}</p>}
            </div>
        </div>
    );

    const renderBoxNav = () => (
        <div className="card">
            {!isPdfPage && (
                <ul className="navbar">
                    {routerQuoteDetailData.map((item) => (
                        <li key={item.path}>
                            <Link
                                to={pathName(item.path)}
                                className={
                                    isCheckPathName(item.path) ? 'active' : ''
                                }
                            >
                                {isCheckPathName(item.path) && (
                                    <img
                                        alt=""
                                        className="arrowLeft"
                                        src={icons.arrowLeft}
                                    />
                                )}
                                {item.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
            <a
                href={`${ENV.URL_PAYMENT}/quotes/QV${quoteId}`}
                className="btn-pay"
                target="_blank"
                rel="noreferrer"
            >
                Secure Quote Now for £{formatCurrency(totalDeposit)}
            </a>
        </div>
    );

    const renderMiniCart = () => (
        <div className="card mini-basket">
            <div className="reference">Quote reference: {quoteId}</div>
            <CartWrap />
        </div>
    );

    const renderShareQuote = () => (
        <>
            <Button
                type="primary"
                className="btnShare"
                ghost
                onClick={handleShowModal}
            >
                Share Quote <FontAwesomeIcon icon={faShareNodes} />
            </Button>
            <ModalComponent
                width={500}
                visible={isModalVisible}
                onClose={handleCloseModal}
                title={'Share your quote with your fellow golfers'}
                content={<CopyLinkVersion onDoneCopy={handleCloseModal} />}
            />
        </>
    );

    const renderDownloadPdf = () => (
        <Button
            type="primary"
            className="btnShare"
            ghost
            onClick={handleDownloadPdf}
            style={{ marginBottom: '1rem' }}
            loading={isLoadingDownloadPdf}
        >
            Download PDF <FontAwesomeIcon icon={faDownload} />
        </Button>
    );

    const renderBestPrice = () => (
        <div className="card best-price">
            <Flex align="center" gap={10}>
                <div className="img">
                    <img alt="logo" src={images.bestPrice} />
                </div>
                <div className="">
                    <div className="title">
                        This quote is only valid for 48 hours
                    </div>
                    <div>
                        Availability is limited, so act quickly to secure your
                        trip!
                    </div>
                </div>
            </Flex>
        </div>
    );

    const renderLoyalty = () => (
        <div className="card loyalty">
            <Flex align="top" gap={10}>
                <div className="img">
                    <img alt="logo" src={loyaltySvg} style={{width: "93px"}} />
                </div>
                <div className="">
                    <div className="title">
                        What if this golf holiday paid for your next one?
                    </div>
                    <div>
                        Earn points on every booking with{' '}
                        <a
                            href="https://www.yourgolftravel.com/clubhouse"
                            target="_blank"
                            rel="noreferrer"
                        >
                            YGT Clubhouse Rewards
                        </a>
                    </div>
                </div>
            </Flex>
        </div>
    );

    return (
        <NavbarQuoteDetailStyle>
            {getIsSafariTemplate && <Lifetime />}
            {!getIsSafariTemplate && (
                <>
                    {renderBoxNav()}
                    {renderMiniCart()}
                </>
            )}

            {renderConsultant()}
            {renderBestPrice()}
            {getIsSafariTemplate && <PaymentSchedule />}
            {renderLoyalty()}
            {isEvent && !getIsSafariTemplate && (
                <YourMasterComponent atAGlance={atAGlance} />
            )}
            {!isPdfPage && !getIsSafariTemplate && (
                <>
                    {isEvent && isCheckPathName('itineraryInDetail') && (
                        <ItineraryScrollComponent />
                    )}
                    {versionId &&
                        quotesArray.length === 0 &&
                        renderDownloadPdf()}
                    {versionId &&
                        !queryParamsMultipleQuotes &&
                        renderShareQuote()}
                </>
            )}
        </NavbarQuoteDetailStyle>
    );
};

export default NavbarQuoteDetail;
